import _classCallCheck from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/nooperation
 */
import Operation from './operation';
/**
 * Operation which is doing nothing ("empty operation", "do-nothing operation", "noop"). This is an operation,
 * which when executed does not change the tree model. It still has some parameters defined for transformation purposes.
 *
 * In most cases this operation is a result of transforming operations. When transformation returns
 * {@link module:engine/model/operation/nooperation~NoOperation} it means that changes done by the transformed operation
 * have already been applied.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var NoOperation =
/*#__PURE__*/
function (_Operation) {
  _inherits(NoOperation, _Operation);

  function NoOperation() {
    _classCallCheck(this, NoOperation);

    return _possibleConstructorReturn(this, _getPrototypeOf(NoOperation).apply(this, arguments));
  }

  _createClass(NoOperation, [{
    key: "clone",

    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/nooperation~NoOperation} Clone of this operation.
     */
    value: function clone() {
      return new NoOperation(this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/nooperation~NoOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new NoOperation(this.baseVersion + 1);
    }
  }, {
    key: "_execute",
    value: function _execute() {}
    /**
     * @inheritDoc
     */

  }, {
    key: "type",
    get: function get() {
      return 'noop';
    }
  }], [{
    key: "className",
    get: function get() {
      return 'NoOperation';
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `NoOperation( ${ this.baseVersion } )`;
    // @if CK_DEBUG_ENGINE // }

  }]);

  return NoOperation;
}(Operation);

export { NoOperation as default };